import React, { useState } from 'react';
import { ChevronLeft, ChevronRight, Video, Phone } from 'lucide-react';
import { fmtDate } from './ui.jsx';
import { relatedName } from '../adapters.js';

const DOW = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
const TODAY = new Date();
TODAY.setHours(0, 0, 0, 0);

const typeTag = { Meeting: { label: 'Video call', icon: Video }, Call: { label: 'Phone call', icon: Phone } };

export default function CalendarWidget({ tasks = [], accounts = [], partners = [] }) {
  const [cursor, setCursor] = useState(new Date(TODAY.getFullYear(), TODAY.getMonth(), 1));

  const year = cursor.getFullYear(), month = cursor.getMonth();
  const firstDow = new Date(year, month, 1).getDay();
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const daysInPrevMonth = new Date(year, month, 0).getDate();

  const eventDays = new Set(
    tasks
      .filter((t) => { const d = new Date(t.due); return d.getFullYear() === year && d.getMonth() === month; })
      .map((t) => new Date(t.due).getDate())
  );

  const cells = [];
  for (let i = firstDow - 1; i >= 0; i--) cells.push({ day: daysInPrevMonth - i, muted: true });
  for (let d = 1; d <= daysInMonth; d++) cells.push({ day: d, muted: false });
  let nextDay = 1;
  while (cells.length % 7 !== 0) cells.push({ day: nextDay++, muted: true });

  const upcoming = tasks
    .filter((t) => t.type === 'Meeting' && t.status !== 'Done' && new Date(t.due) >= TODAY)
    .sort((a, b) => new Date(a.due) - new Date(b.due))
    .slice(0, 3);

  return (
    <div className="card">
      <div className="card-body">
        <div className="cal-head">
          <span className="cal-month">{cursor.toLocaleDateString('en-IN', { month: 'long', year: 'numeric' })}</span>
          <div className="cal-nav">
            <button onClick={() => setCursor(new Date(year, month - 1, 1))}><ChevronLeft size={13} /></button>
            <button onClick={() => setCursor(new Date(year, month + 1, 1))}><ChevronRight size={13} /></button>
          </div>
        </div>
        <div className="cal-grid">
          {DOW.map((d, i) => <span className="cal-dow" key={i}>{d}</span>)}
        </div>
        <div className="cal-grid">
          {cells.map((c, i) => {
            const isToday = !c.muted && year === TODAY.getFullYear() && month === TODAY.getMonth() && c.day === TODAY.getDate();
            const hasEvent = !c.muted && eventDays.has(c.day);
            return (
              <span key={i} className={`cal-day ${c.muted ? 'cal-day--muted' : ''} ${isToday ? 'cal-day--today' : ''} ${hasEvent ? 'cal-day--has-event' : ''}`}>
                {c.day}
              </span>
            );
          })}
        </div>
        <div className="cal-meetings">
          {upcoming.length === 0 && <div className="cal-empty">No upcoming meetings.</div>}
          {upcoming.map((t) => {
            const tag = typeTag[t.type];
            return (
              <div className="cal-meeting" key={t.id}>
                <div className="cal-meeting-top">
                  <div>
                    <div className="cal-meeting-title">{t.title}</div>
                    <div className="cal-meeting-time">{fmtDate(t.due)} · {relatedName(t, accounts, partners)}</div>
                  </div>
                </div>
                {tag && <span className="cal-meeting-tag"><tag.icon size={11} style={{ marginRight: 4, verticalAlign: -2 }} />{tag.label}</span>}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
